import React, { useId } from "react";

export default function DynamicDeliverableSection({ data }) {
  const titleId = useId();
  if (!data?.items?.length) return null;

  return (
    <section className="dynamic-deliverable-section" aria-labelledby={titleId}>
      <div className="container">
        <div className="dynamic-deliverable-heading text-center">
          <span className="main-title">{data.eyebrow}</span>
          <h2 className="heading" id={titleId}>{data.title}<br />{data.titleSecondLine}</h2>
        </div>
        <ul className="dynamic-deliverable-list">
          {data.items.map((item) => (
            <li className="dynamic-deliverable-row" key={item.before}>
              <span className="dynamic-deliverable-before">{item.before}</span>
              <svg className="dynamic-deliverable-arrow" viewBox="0 0 100 24" fill="none" aria-hidden="true" focusable="false">
                <path d="M1 12h96M88 3l9 9-9 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="dynamic-deliverable-after"><span className="visually-hidden">To: </span>{item.after}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
